import React from 'react'
import { Icon } from 'antd';
import "./style/index.less";
class App extends React.Component {
  componentDidMount() {
  }
  componentWillReceiveProps(nextProps) {
  }
  render() {
    const { datas } = this.props;
    return (
      <div className='cs-navigation'>
        {
          datas && datas.map((item,index) => {
            const dataLen = datas.length-1;
            return (
              <div className='navigation-list' key={item.key}>
                <span
                  className={`${index === dataLen && 'navigation-now'}`}
                  onClick={() => {
                    index !== dataLen && typeof this.props.onClick === 'function' && this.props.onClick(item)
                  }}
                >{item.breadcrumbName}
                </span>
                {index !== dataLen && <Icon type="right" />}
              </div>
            )
          })
        }
      </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/components/public/navigation/index.js